import React from "react";

export default function Image({ webp, src, ...rest }) {
  const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;

  return isIE11 ? <img src={src} {...rest} alt=" " /> : <img src={webp} {...rest} alt=" " />;
}
